import React from "react";
import content from "../utils/content.json";
import LaunchIcon from "@material-ui/icons/Launch";

function CommunityContributions() {
  const data = content.content.communityContribution;

  return (
    <section id="community-contributions" className="container section">
      <h2 id="resume_header" className="section__title">
        {data.judging.title}
      </h2>
      <div className="row">
        <div className="col-md-8 section__resume resume-list">
          {data.judging.judging.map((j, index) => (
            <div className="resume-list__block" key={index}>
              <p className="resume-list__block-title-with-icon">
                {j.name}
                {j.link && (
                  <a href={j.link} target="_blank" rel="noopener noreferrer">
                    <LaunchIcon fontSize="small" />
                  </a>
                )}
              </p>
              <p className="resume-list__block-date">{j.date}</p>
              <p className="resume-list__block-description">{j.description}</p>
            </div>
          ))}
        </div>
      </div>

      <h2 id="resume_header" className="section__title">
        {data.memberships.title}
      </h2>
      <div className="row">
        <div className="col-md-8 section__resume resume-list">
          {data.memberships.memberships.map((j, index) => (
            <div className="resume-list__block" key={index}>
              <p className="resume-list__block-title-with-icon">
                {j.name}
                {j.link && (
                  <a href={j.link} target="_blank" rel="noopener noreferrer">
                    <LaunchIcon fontSize="small" />
                  </a>
                )}
              </p>
              <p className="resume-list__block-date">{j.date}</p>
              <p className="resume-list__block-description">{j.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CommunityContributions;
